/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import WizardStep from 'shared/ui/components/WizardStep.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import LegalPicker from 'shared/ui/components/form-components/pickers/LegalPicker.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import TypesOptions from './TypesOptions.vue';
import WorkspaceCategory from 'shared/ui/components/form-components/WorkspaceCategory.vue';
import AnonymizeAllOrByDomain from '../../AnonymizeAllOrByDomain.vue';

// Mixins
import baseWorkspaceSettings from 'ui/mixins/workspaces/base-settings';
import creationWorkspaceSettings from 'ui/mixins/workspaces/creation-settings';
import moment from 'moment-timezone';
import { get } from 'lodash';

/**
 *
 * @category ui.components.wizards.create-workspace
 * @exports WorkspaceForm
 * @component
 */
const __vue_script__ = {
    name: 'WorkspaceForm',

    components: { DatetimePicker, BaseInput, BaseSelect, Checkbox, LegalPicker, Toggler, TypesOptions, WorkspaceCategory, AnonymizeAllOrByDomain },

    extends: WizardStep,

    mixins: [baseWorkspaceSettings, creationWorkspaceSettings],

    data() {
        return {
            exclude_readonly: true,
            canCreateProdEvents: false,
            categories: null,
            displayAnonymization: false,
            forcedAnonymization: false,
        };
    },

    computed: {
        minStartDate() {
            const isAdminOrSupport = this.$services.user.matchesRoles(
                { globalRole: 'superadmin' },
                { globalRole: 'spotme_support' }
            );
            if (isAdminOrSupport) {
                return '';
            }

            const now = moment().tz(this.form.timezone);

            if (!this.form.end_date) {
                return now.startOf('day').toDate();
            }

            const endMinusMonth = moment(this.form.end_date)
                .tz(this.form.timezone)
                .subtract(1, 'month');
            const min = endMinusMonth.isBefore(now) ? now : endMinusMonth;

            return min.startOf('day').toDate();
        },

        maxEndDate() {
            const isAdminOrSupport = this.$services.user.matchesRoles(
                { globalRole: 'superadmin' },
                { globalRole: 'spotme_support' }
            );
            if (isAdminOrSupport || get(this, 'form.organization.workspace_defaults.unrestricted_workspace_duration')) {
                return '';
            }

            const start = this.form.start_date ? this.form.start_date : Date.now();

            return moment(start)
                .tz(this.form.timezone)
                .add(1, 'month')
                .startOf('day')
                .toDate();
        }
    },

    created() {
        // Timezones
        const browserTz = this.$utils.time.getBrowserTimezone();

        if (!this.form.timezone && this.timezones.includes(browserTz)) {
            this.form.timezone = browserTz;
        }

        // test event
        const orgId = this.form.organization._id;

        this.canCreateProdEvents = this.$services.user.hasPermission('global_actions.create_production_event', { org_id: orgId });

        if (!this.canCreateProdEvents) {
            this.form.test_workspace = true;
        }

        this.displayAnonymization = this.form.organization.enable_anonymization;
        this.forcedAnonymization = this.form.organization.workspace_defaults?.force_anonymization;

        if (this.forcedAnonymization) {
            this.form.anonymization = true;
        }
    },

    methods: {
        /**
          * Utility method to make the template more readable
          *
          * @param {String} key the key to translate
          *
          * @return {String} the translated message
          */
        t(key) {
            return this.$i18n.t(`wizards.create_workspace.form.${key}`).toString();
        },

        setTypes(types) {
            Object.assign(this.form, types);
            this.$nextTick(() => {
                this.validate(true);
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"workspace-form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.details')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.t('name'),"type":"text","name":"name","focused":_vm.focus == 'name',"errors":errors},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})]}}])}),_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"start_date"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{ref:"start_date",attrs:{"label":_vm.t('start_date'),"type":"datetime","show-second":false,"minute-step":30,"name":"start_date","focused":_vm.focus == 'start_date',"not-before":_vm.minStartDate,"not-after":_vm.form.end_date,"format":_vm.dateFormat,"errors":errors},model:{value:(_vm.form.start_date),callback:function ($$v) {_vm.$set(_vm.form, "start_date", $$v)},expression:"form.start_date"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"end_date"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{ref:"end_date",attrs:{"label":_vm.t('end_date'),"type":"datetime","show-second":false,"minute-step":30,"name":"end_date","focused":_vm.focus == 'end_date',"not-before":_vm.form.start_date,"not-after":_vm.maxEndDate,"disabled":!_vm.form.start_date,"format":_vm.dateFormat,"default-value":_vm.form.start_date,"errors":errors},model:{value:(_vm.form.end_date),callback:function ($$v) {_vm.$set(_vm.form, "end_date", $$v)},expression:"form.end_date"}})]}}])})],1),_c('div',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.t('end_date_hint')))])]),(_vm.form.organization.workspace_defaults.enable_category)?[(_vm.form.organization.workspace_defaults.category_multiselect)?_c('validation-provider',{attrs:{"slim":true,"name":"categories"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"focused":_vm.focus == 'categories',"organization":_vm.form.organization,"name":"categories","errors":errors},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}})]}}],null,false,2875120264)}):_c('validation-provider',{attrs:{"slim":true,"name":"category"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"focused":_vm.focus == 'category',"organization":_vm.form.organization,"name":"category","errors":errors},model:{value:(_vm.form.category),callback:function ($$v) {_vm.$set(_vm.form, "category", $$v)},expression:"form.category"}})]}}],null,false,215304110)})]:_vm._e()],2),_c('types-options',{attrs:{"form":_vm.form,"focused":_vm.focus},on:{"input":_vm.setTypes},model:{value:(_vm.types),callback:function ($$v) {_vm.types=$$v},expression:"types"}}),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.privacy')))]),_c('p',[_vm._v(_vm._s(_vm.t('privacy_intro')))]),_c('div',{staticClass:"grouped-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"privacy_documents"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('legal-picker',{ref:"privacy_documents",attrs:{"org-name":_vm.form.organization.name,"label":_vm.t('privacy_documents'),"placeholder":_vm.t('privacy_documents_placeholder'),"name":"privacy_documents","focused":_vm.focus == 'privacy_documents',"errors":errors},model:{value:(_vm.form.privacy_documents),callback:function ($$v) {_vm.$set(_vm.form, "privacy_documents", $$v)},expression:"form.privacy_documents"}})]}}])})],1)]),(_vm.container_apps.length)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.app')))]),_c('div',{staticClass:"grouped-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"container_app"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"container_app",attrs:{"label":_vm.t('container_app'),"placeholder":_vm.t('container_app_placeholder'),"name":"container_app","options":_vm.container_apps,"track-by":"_id","focused":_vm.focus == 'container_app',"hint":_vm.t('container_app_hint'),"errors":errors},model:{value:(_vm.form.container_app),callback:function ($$v) {_vm.$set(_vm.form, "container_app", $$v)},expression:"form.container_app"}})]}}],null,false,2222489234)})],1)]):_vm._e(),(_vm.displayAnonymization)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.anonymization')))]),_c('div',{staticClass:"alert alert-warning anonymized-alert"},[_vm._v(_vm._s(_vm.forcedAnonymization ? _vm.t('anonymization_enabled') : _vm.t('one_shot_setting')))]),(!_vm.forcedAnonymization)?_c('toggler',{ref:"anonymization",attrs:{"focused":_vm.focus == 'anonymization',"name":"anonymization","on-label":"wizards.create_workspace.form.anonymized","off-label":"wizards.create_workspace.form.not_anonymized"},model:{value:(_vm.form.anonymization),callback:function ($$v) {_vm.$set(_vm.form, "anonymization", $$v)},expression:"form.anonymization"}}):_vm._e(),(!_vm.forcedAnonymization && _vm.form.anonymization)?_c('anonymize-all-or-by-domain',{model:{value:(_vm.form.anonymization_domains),callback:function ($$v) {_vm.$set(_vm.form, "anonymization_domains", $$v)},expression:"form.anonymization_domains"}}):_vm._e()],1):_vm._e(),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.extra')))]),_c('checkbox',{attrs:{"label":_vm.t('test_workspace'),"name":"test_workspace","hint":_vm.canCreateProdEvents ? _vm.t('test_workspace_hint') : _vm.t('test_workspace_hint_member'),"focused":_vm.focus == 'test_workspace',"disabled":!_vm.canCreateProdEvents},model:{value:(_vm.form.test_workspace),callback:function ($$v) {_vm.$set(_vm.form, "test_workspace", $$v)},expression:"form.test_workspace"}})],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WorkspaceForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__